/** 西游角色合集（baiwuchang.FBX）— 由脚本从 FBX 网格自动生成 */
import { resolveStaticUrl } from '@/config/staticAssets'

export const XIYOU_CHARACTERS = [

  {
    'id': 'heibaiwuchang',
    'label': '白无常',
    'emoji': '👻',
    'meshKeep': [
      'default018'
    ],
    'textureFile': 'cardHeiBaiWuChang.Out.png',
    'thumbFile': 'baiwuchang.png'
  },
  {
    'id': 'heiwuchang',
    'label': '黑无常',
    'emoji': '👻',
    'meshKeep': [
      'default018'
    ],
    'textureFile': 'cardHeiwuchang.png',
    'thumbFile': 'heiwuchang.png'
  },
  {
    'id': 'donghailongwang',
    'label': '东海龙王',
    'emoji': '🐉',
    'meshKeep': [
      'default008'
    ],
    'textureFile': 'cardDongHaiLongWang.Out.png',
    'thumbFile': 'donghailongwangcopy.png'
  },
  {
    'id': 'erlangshen',
    'label': '二郎神',
    'emoji': '⚔️',
    'meshKeep': [
      'default010'
    ],
    'textureFile': 'cardErLangShen.Out.png',
    'thumbFile': 'erlangshen.png'
  },
  {
    'id': 'guanyin',
    'label': '观音',
    'emoji': '🙏',
    'meshKeep': [
      'default014'
    ],
    'textureFile': 'cardGuanYin.Out.png',
    'thumbFile': 'guanyin.png'
  },
  {
    'id': 'hujing',
    'label': '虎精',
    'emoji': '🧙',
    'meshKeep': [
      'default025'
    ],
    'textureFile': 'cardHuJing.Out (2).png'
  },
  {
    'id': 'niumowang',
    'label': '牛魔王',
    'emoji': '🐮',
    'meshKeep': [
      'default043',
      'default044'
    ],
    'textureFile': 'cardNiuMoWang.Out.png',
    'thumbFile': 'niumowang.png',
    'targetHeight': 1.15,
    'scaleBoost': 2.4
  },
  {
    'id': 'rulaiboss01',
    'label': '如来',
    'emoji': '🧙',
    'meshKeep': [
      'default061'
    ],
    'textureFile': 'cardRuLaiBoss01.Out.png'
  },
  {
    'id': 'shaseng',
    'label': '沙僧',
    'emoji': '👨‍🦲',
    'meshKeep': [
      'default066',
      'default067'
    ],
    'textureFile': 'cardShaseng.png',
    'thumbFile': 'shaseng.png'
  },
  {
    'id': 'shejing',
    'label': '蛇精',
    'emoji': '🐍',
    'meshKeep': [
      'default068',
      'default069'
    ],
    'textureFile': 'cardSheJing.Out.png'
  },
  {
    'id': 'siseng',
    'label': '寺僧',
    'emoji': '🧙',
    'meshKeep': [
      'default075'
    ],
    'textureFile': 'cardSiSeng.Out.png'
  },
  {
    'id': 'sunwukong',
    'label': '孙悟空',
    'emoji': '🐒',
    'meshKeep': [
      'default076',
      'default077'
    ],
    'textureFile': 'cardsSunwukong.png',
    'thumbFile': 'sunwukong.png'
  },
  {
    'id': 'taibaijinxing',
    'label': '太白金星',
    'emoji': '🧙',
    'meshKeep': [
      'default078'
    ],
    'textureFile': 'cardTaiBaiJinXing.Out.png'
  },
  {
    'id': 'taishanglaojun',
    'label': '太上老君',
    'emoji': '🧙',
    'meshKeep': [
      'default079'
    ],
    'textureFile': 'cardTaiShangLaoJun.Out.png',
    'thumbFile': 'taishanglaojun.png'
  },
  {
    'id': 'heshang',
    'label': '和尚',
    'emoji': '🧘',
    'meshKeep': [
      'default080'
    ],
    'textureFile': 'cardHeshang.Out.png',
    'thumbFile': 'heshang.png',
    /** 合集 default080：放置时需默认俯仰 -90°（滑条「仰」端）才站正 */
    'defaultPropPitch': -Math.PI / 2
  },
  {
    'id': 'tangseng',
    'label': '唐僧',
    'emoji': '🧘',
    'meshKeep': [
      'default080'
    ],
    'textureFile': 'cardTangseng.png',
    'thumbFile': 'tangseng.png'
  },
  {
    'id': 'tangseng05',
    'label': '唐僧',
    'emoji': '🧘',
    'meshKeep': [
      'default081'
    ],
    'textureFile': 'cardTangSeng05.Out.png'
  },
  {
    'id': 'tianbing',
    'label': '天兵',
    'emoji': '🧙',
    'meshKeep': [
      'default082'
    ],
    'textureFile': 'CardTianBing.Out.png'
  },
  {
    'id': 'tianjiang',
    'label': '天将',
    'emoji': '🧙',
    'meshKeep': [
      'default083'
    ],
    'textureFile': 'cardTianJiang.Out (2).png'
  },
  {
    'id': 'tianjiang02',
    'label': '天将二',
    'emoji': '🧙',
    'meshKeep': [
      'default084'
    ],
    'textureFile': 'cardTianJiang02.Out (2).png'
  },
  {
    'id': 'tianpengyuanshuai',
    'label': '天蓬元帅',
    'emoji': '🧙',
    'meshKeep': [
      'default085'
    ],
    'textureFile': 'cardTianPengYuanShuai.Out (2).png'
  },
  {
    'id': 'xiaotianquan',
    'label': '哮天犬',
    'emoji': '🐕',
    'meshKeep': [
      'default093',
      'default094'
    ],
    'textureFile': 'cardXiaoTianQuan.Out (2).png'
  },
  {
    'id': 'xiaobailong',
    'label': '小白龙',
    'emoji': '🐉',
    'meshKeep': [
      'default090'
    ],
    'textureFile': 'cardXiaoBaiLong.Out.png'
  },
  {
    'id': 'xiaolongnv',
    'label': '小龙女',
    'emoji': '🧙',
    'meshKeep': [
      'default091',
      'default092'
    ],
    'textureFile': 'cardXiaoLongNv.Out.png'
  },
  {
    'id': 'xiejiang',
    'label': '蟹将',
    'emoji': '🦀',
    'meshKeep': [
      'default095',
      'default096'
    ],
    'textureFile': 'cardXieJiang.Out (2).png'
  },
  {
    'id': 'xingxian',
    'label': '杏仙',
    'emoji': '🧙',
    'meshKeep': [
      'default097'
    ],
    'textureFile': 'cardXingXian.Out.png'
  },
  {
    'id': 'yanluowang',
    'label': '阎罗王',
    'emoji': '🧙',
    'meshKeep': [
      'default099',
      'default100'
    ],
    'textureFile': 'cardYanLuoWang.Out.png'
  },
  {
    'id': 'yanluowangboss02',
    'label': '阎罗王二',
    'emoji': '🧙',
    'meshKeep': [
      'default101',
      'default102'
    ],
    'textureFile': 'cardYanLuoWangBoss02.Out.png'
  },
  {
    'id': 'yanluowangboss03',
    'label': '阎罗王三',
    'emoji': '🧙',
    'meshKeep': [
      'default103',
      'default104'
    ],
    'textureFile': 'cardYanLuoWangBoss03.Out.png'
  },
  {
    'id': 'yezhu',
    'label': '野猪',
    'emoji': '🧙',
    'meshKeep': [
      'default109'
    ],
    'textureFile': 'cardYeZhu.Out.png'
  },
  {
    'id': 'yecha',
    'label': '夜叉',
    'emoji': '🧙',
    'meshKeep': [
      'default107'
    ],
    'textureFile': 'cardYeCha.Out.png'
  },
  {
    'id': 'yecha01',
    'label': '夜叉',
    'emoji': '🧙',
    'meshKeep': [
      'default108'
    ],
    'textureFile': 'cardYeCha01.Out.png'
  },
  {
    'id': 'yumianhuli',
    'label': '玉面狐狸',
    'emoji': '🧙',
    'meshKeep': [
      'default110'
    ],
    'textureFile': 'cardYuMianHuLi.Out.png'
  },
  {
    'id': 'yutujing',
    'label': '玉兔精',
    'emoji': '🐰',
    'meshKeep': [
      'default111'
    ],
    'textureFile': 'cardYuTuJing.Out.png'
  },
  {
    'id': 'zhenyuandaxian',
    'label': '镇元大仙',
    'emoji': '🧙',
    'meshKeep': [
      'default112',
      'default113'
    ],
    'textureFile': 'cardZhenYuanDaXian.Out.png'
  },
  {
    'id': 'zhizhujing',
    'label': '蜘蛛精',
    'emoji': '🕷️',
    'meshKeep': [
      'default114'
    ],
    'textureFile': 'cardZhiZhuJing.Out.png'
  },
  {
    'id': 'zhizhujingboss',
    'label': '蜘蛛精',
    'emoji': '🕷️',
    'meshKeep': [
      'default115'
    ],
    'textureFile': 'cardZhiZhuJingBoss.Out.png'
  },
  {
    'id': 'zhizhukuangbao',
    'label': '蜘蛛精(狂暴)',
    'emoji': '🕷️',
    'meshKeep': [
      'default116'
    ],
    'textureFile': 'cardZhiZhuKuangBao.Out.png'
  },
  {
    'id': 'zhubajie',
    'label': '猪八戒',
    'emoji': '🐷',
    'meshKeep': [
      'default117'
    ],
    'textureFile': 'cardZhuBaJie.Out.png',
    'thumbFile': 'zhubajie.png'
  },
  {
    'id': 'zhuganglie',
    'label': '猪刚鬣',
    'emoji': '🐷',
    'meshKeep': [
      'default118'
    ],
    'textureFile': 'cardZhuGangLie.Out (2).png'
  },
  {
    'id': 'baiyinvzi',
    'label': 'baiyinvzi',
    'emoji': '🧙',
    'meshKeep': [
      'default004'
    ],
    'textureFile': 'cardBaiYiNvZi.Out (2).png'
  },
  {
    'id': 'baoxiangguowushi',
    'label': 'baoxiangguowushi',
    'emoji': '🧙',
    'meshKeep': [
      'default005'
    ],
    'textureFile': 'cardBaoXiangGuoWuShi.Out (2).png'
  },
  {
    'id': 'dujiaosidawang',
    'label': '独角犀大王',
    'emoji': '🦏',
    'meshKeep': [
      'default009'
    ],
    'textureFile': 'cardDuJiaoSiDaWang.Out.png',
    'thumbFile': 'duJiaoSiDaWang.png'
  },
  {
    'id': 'erlangshengold_1.png',
    'label': 'erlangshengold_1.png',
    'emoji': '🧙',
    'meshKeep': [
      'default011'
    ],
    'textureFile': 'cardErLangShengold_1.png'
  },
  {
    'id': 'huangpaolaoguai',
    'label': 'huangpaolaoguai',
    'emoji': '🧙',
    'meshKeep': [
      'default024'
    ],
    'textureFile': 'CardHuangPaoLaoGuai.Out.png'
  },
  {
    'id': 'hulidaxian',
    'label': 'hulidaxian',
    'emoji': '🧙',
    'meshKeep': [
      'default026'
    ],
    'textureFile': 'cardHuLiDaXian.Out.png'
  },
  {
    'id': 'hunshimowang02',
    'label': 'hunshimowang02',
    'emoji': '🧙',
    'meshKeep': [
      'default028'
    ],
    'textureFile': 'cardHunShiMoWang02.Out.png'
  },
  {
    'id': 'rulai',
    'label': '如来',
    'emoji': '🙏',
    'meshKeep': [
      'default059'
    ],
    'textureFile': 'cardRuLai.Out.png',
    'thumbFile': 'rulai.png'
  },
  {
    'id': 'shanzei02',
    'label': 'shanzei02',
    'emoji': '🧙',
    'meshKeep': [
      'default065'
    ],
    'textureFile': 'cardShanZei02.Out.png'
  },
  {
    'id': 'tuotalitianwang',
    'label': 'tuotalitianwang',
    'emoji': '🧙',
    'meshKeep': [
      'default087'
    ],
    'textureFile': 'cardTuoTaLiTianWang.Out.png'
  },
  {
    'id': 'tuotalitianwang02',
    'label': 'tuotalitianwang02',
    'emoji': '🧙',
    'meshKeep': [
      'default088'
    ],
    'textureFile': 'cardTuoTaLiTianWang02.Out.png'
  },
  {
    'id': 'yanluowangkuangbao02',
    'label': 'yanluowangkuangbao02',
    'emoji': '🧙',
    'meshKeep': [
      'default105'
    ],
    'textureFile': 'cardYanLuoWangKuangBao02.Out.png'
  },
  {
    'id': 'yanluowangkuangbao03',
    'label': 'yanluowangkuangbao03',
    'emoji': '🧙',
    'meshKeep': [
      'default106'
    ],
    'textureFile': 'cardYanLuoWangKuangBao03.Out.png'
  }
]

/** 已引入贴图+缩略图的角色（有 thumbFile 才会出现在沙具列表） */
export const XIYOU_INTRODUCED_CHARACTERS = XIYOU_CHARACTERS.filter(
  (c) => c.thumbFile
)

export const XIYOU_TEXTURE_FILES = XIYOU_INTRODUCED_CHARACTERS.map(
  (c) => c.textureFile
)

export const XIYOU_THUMB_DIR = resolveStaticUrl('/static/models/xiyou/thumbs/')

export const XIYOU_SAND_ENTRIES = XIYOU_INTRODUCED_CHARACTERS.map((c) => {
  const entry = {
    label: c.label,
    emoji: c.emoji,
    modelKey: `xiyou:${c.id}`,
    thumbUrl: resolveStaticUrl(
      c.thumbFile.indexOf('/') === 0
        ? c.thumbFile
        : `${XIYOU_THUMB_DIR}${c.thumbFile}`
    )
  }
  if (c.previewUrl) entry.previewUrl = resolveStaticUrl(c.previewUrl)
  return entry
})



// WEBPACK FOOTER //
// ./src/config/xiyouCharacters.js